package pl.decks.personal.pages.ievp.sections.experience

enum class ExperienceBreakdownPanel(val optionText: String) {
    ROLE_PROFILE("Role Profile"),
    WENT_WELL("Went well"),
    NOT_SO_WELL("Not-so-well"),
    ;
}
